// 브라우저단에 토큰값은 있는데 관리자가 응답값 지웠을경우 값이 없어진상태이므로 토큰(로컬스터리지)값 지워준다
import { useEffect } from 'react'
import { useLazyQuery } from '@apollo/react-hooks'
import { useDispatch } from 'react-redux'
import { SurveyLiveIpContainer } from 'container'
import { SHOW as ERRORPAGESHOW } from 'reducer/errorPage'
import { GET_SURVEY_ANALYSIS_USER } from 'gql/survey_analysis_users'
import { getTokenname, getStartsTokenname, parseGraphqlError } from 'utils'
import VerificationEmailContainer from './VerificationEmail'

function Component(props) {
    const { survey_no } = props

    const tokenname = getTokenname(survey_no, props.root)

    const startsTokenname = getStartsTokenname(survey_no)

    const dispatch = useDispatch()

    const [ getData, { loading } ] = useLazyQuery(GET_SURVEY_ANALYSIS_USER, {
        onError: (e) => {
            if (parseGraphqlError(e) === 'No User') {
                localStorage.removeItem(tokenname)
                sessionStorage.removeItem(startsTokenname)
            } else {
                dispatch({ type: ERRORPAGESHOW })
            }
            
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only'
    })


    useEffect(() => {
        if (localStorage.getItem(tokenname)) {
            getData({
                variables: { 
                    survey_no, 
                    token: localStorage.getItem(tokenname), 
                    mode: 'live'
                }
            })
        }
    }, [ survey_no, tokenname, getData ])

    // 토큰 값이 있는데 data값이 없으면 잠시 대기
    if (localStorage.getItem(tokenname) && loading) return null

    return (
        <>
        {
            props.root === 'ip' ? <SurveyLiveIpContainer {...props}/> : 
            props.root === 'email' && <VerificationEmailContainer {...props}/>
        }
        </>
    )
}

export default Component